<template>
  <div v-if="LOADING">
    <mainLoader />
  </div>
  <Layout v-if="!LOADING && GET_USER && currentURI != '/login'" />
  <LoginLayout v-if="!LOADING && !GET_USER && currentURI == '/login'" />
</template>
<script>
import { mapGetters } from 'vuex';
import Layout from "@/views/layout.vue";
import LoginLayout from "@/views/login_layout.vue";

export default {
  data(){
    return {
      currentURI: '/',
    }
  },
  computed: {
    ...mapGetters(['GET_USER','LOADING']),
  },
  components: {
    Layout,
    LoginLayout,
  },
  methods: {
    detectLogin(){
      if(this.LOADING){
        setTimeout(() => this.detectLogin(), 200);
      }else{
        if(!this.GET_USER && this.currentURI != '/login'){
          window.location.href = '/login';
        }
        if(this.GET_USER && this.currentURI == '/login'){
          window.location.href = '/';
        }
      }
    }
  },
  created(){
    this.currentURI = window.location.pathname;
    this.detectLogin();
  }
}
</script>
